import {
  Button,
  Card,
  Flex,
  Heading,
  PlusIcon,
  Text,
} from '@buffer-mono/popcorn'

import styles from './GenerateApiClientCard.module.css'

import type { JSX } from 'react'

interface GenerateApiClientCardProps {
  onGenerate: () => void
}

export function GenerateApiClientCard({
  onGenerate,
}: GenerateApiClientCardProps): JSX.Element {
  return (
    <Card className={styles.card}>
      <Flex direction="column" gap="md">
        <Flex direction="column" gap="2xs">
          <Heading as="h3" size="xsmall">
            Create Your First App Client
          </Heading>

          <Text color="subtle">
            Use app clients to let your users connect their Buffer accounts to
            your app.
          </Text>
        </Flex>
        <Button size="large" onClick={onGenerate}>
          <PlusIcon />
          New Client
        </Button>
      </Flex>
    </Card>
  )
}
